// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

$(function(){

	/* user agent
	 ----------------------------------------------------------------- */
	var spSize = '767px';
	var tbpcSize = '768px';

	var deviceFlgNum = 0;
	var deviceFlg = '';

	if (
		(navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0) ||
		navigator.userAgent.indexOf('iPod') > 0 ||
		( navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1 )
	) {
		deviceFlgNum = 1; // sp
	} else if (
		navigator.userAgent.indexOf('Android') > 0 ||
		navigator.userAgent.indexOf('iPad') > 0
	) {
		deviceFlgNum = 2; // tb
	} else {
		deviceFlgNum = 3; // pc
	}

	function isUserAgent() {
		var ua = navigator.userAgent;

		if(ua.search(/iPhone/) != -1 || ua.search(/iPad/) != -1) {
			// iphone, ipad
			deviceFlg = 'apple';
		} else {
			// Andoird, other
			deviceFlg = 'other';
		}
	}
	isUserAgent();



	/* video
	 ----------------------------------------------------------------- */
	if ( deviceFlgNum == 1 ) {
		$('.js-video').remove();
	}



	/* js animation
	 ----------------------------------------------------------------- */
	var $window = $(window),
		$body = $('body'),
		$inview = $('.js-inview, .js-inviewlate'),
		$doc = $('html, body');

	$inview.each(function () {
		var elmPos = $(this).offset().top;
		var wst = $window.scrollTop();
		var wh = $window.height();

		if (wst > elmPos - wh) {
			if (!$(this).hasClass('view')) {
				$(this).addClass('view');
				$(this).find('video').addClass('view');
			}
		} else {
			if ($(this).hasClass('view')) {
				$(this).removeClass('view');
				$(this).find('video').removeClass('view');
			}
		}
	});

	$window.on('load scroll resize', function () {
		$inview.each(function () {
			var elmPos = $(this).offset().top;
			var wst = $window.scrollTop();
			var wh = $window.height();

			if (wst > elmPos - wh) {
				if (!$(this).hasClass('view')) {
					$(this).addClass('view');
					$(this).find('video').addClass('view');
				}
			} else {
				if ($(this).hasClass('view')) {
					$(this).removeClass('view');
					$(this).find('video').removeClass('view');
				}
			}
		});
	});



	/* page top
	 ----------------------------------------------------------------- */
	$('.js-page-top').click(function(){
		$('body, html').animate({
			scrollTop: 0
		}, 400);

		return false;
	});



		/* anchor
	 ----------------------------------------------------------------- */
	$('a[href^="#"]').click(function() {
		var speed = 400;
		var href= $(this).attr('href');
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate(
			{
				scrollTop:position
			}, speed, 'swing'
		);
		return false;
	});



	/* header menu ( sp only )
	 ----------------------------------------------------------------- */
	$('.js-header-icon').click(function() {
		$(this).toggleClass('header-icon-link--close');
		$('.header-regist').toggleClass('hidden');
		$('.header-nav-bg').toggleClass('header-nav-bg--active');
		$('.header-nav__body').toggleClass('header-nav__body--active');
	} );

	$(document).on('click touchend', function(event) {
		if ( $('.header-nav-bg').hasClass('header-nav-bg--active') ) {
			if ( !$(event.target).closest('.header-nav__body').length && !$(event.target).closest('.js-header-icon').length ) {
				$('.js-header-icon').toggleClass('header-icon-link--close');
				$('.header-regist').toggleClass('hidden');
				$('.header-nav-bg').toggleClass('header-nav-bg--active');
				$('.header-nav__body').toggleClass('header-nav__body--active');
			}
		}
	});

	$('.header-menu-item__link').click(function() {
		$('.js-header-icon').toggleClass('header-icon-link--close');
		$('.header-regist').toggleClass('hidden');
		$('.header-nav-bg').toggleClass('header-nav-bg--active');
		$('.header-nav__body').toggleClass('header-nav__body--active');
	} );



	/* header regist button ( sp only )
	 ----------------------------------------------------------------- */
//	var btnDisPos = 100;
//	$(window).on('load scroll resize', function() {
//		if ( $(window).scrollTop() >= btnDisPos) {
//			$('.js-header-regist').addClass('header-regist--display');
//		} else {
//			$('.js-header-regist').removeClass('header-regist--display');
//		}
//	} );



	/* sp map links
	 ----------------------------------------------------------------- */
	$('.js-map-links').click(function() {
		var lat = $(this).data('lat');
		var lng = $(this).data('lng');
		var zoom = $(this).data('zoom');
		var mapDomainApple = 'http://maps.apple.com/maps';
		var mapDomainGoogle = 'http://maps.google.com/maps';
		var mapParamater = '?saddr=&daddr=' + lat + ',' + lng + '&z=' + zoom;
		if ( deviceFlg == 'apple' ) {
			window.open( mapDomainApple + mapParamater, '_blank' ) ;
		} else {
			window.open( mapDomainGoogle + mapParamater, '_blank' ) ;
		}

		return false;
	});



	/* form status
	 ----------------------------------------------------------------- */
	$('.js-form-status').click(function() {
		var $val = $(this).val();
		if ( $val == 1 ) {
			$('.js-form-status-toggle').fadeIn('fast');
			$('.js-separation-year').addClass('js-require');
			$('.js-separation-month').addClass('js-require');
//			checkFunc();
		} else {
			$('.js-form-status-toggle').hide();
			$('.js-separation-year').removeClass('js-require');
			$('.js-separation-month').removeClass('js-require');
		}
	} );

	if ( $('input[name=status]:checked').val() == 1 ) {
		$('.js-form-status-toggle').fadeIn('fast');
		$('.js-separation-year').addClass('js-require');
		$('.js-separation-month').addClass('js-require');
	} else {
		$('.js-form-status-toggle').hide();
		$('.js-separation-year').removeClass('js-require');
		$('.js-separation-month').removeClass('js-require');
	}



	/* form validation
	 ----------------------------------------------------------------- */
//	checkFunc();
//
//	function checkFunc() {
//		var check = true;
//		$('.js-require').each(function() {
//			if ( $(this).val() == '' ) {
//				check = false;
//			}
//		});
//
//		if ( !$('.js-require-email').val().match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) ) {
//			check = false;
//		}
//
//		var radio_array1 = [];
//		$('.js-require-radio').each(function() {
//			radio_array1.push( $(this).prop('checked') );
//		});
//		if ( radio_array1.indexOf(true) == -1 ) {
//			check = false;
//		}
//
//		var radio_array2 = [];
//		$('.js-form-status').each(function() {
//			radio_array2.push( $(this).prop('checked') );
//		});
//		if ( radio_array2.indexOf(true) == -1 ) {
//			check = false;
//		}
//
//		if ( check === true ) {
//			$('.js-form-submit').prop('disabled', false);
//		} else {
//			$('.js-form-submit').prop('disabled', true);
//		}
//	}
//
//	// $('.js-require').bind('keydown keyup keypress change', function() {
//	$(document).on('keydown keyup keypress change', '.js-require', function() {
//		checkFunc();
//	});
//
//	$('.js-require-radio').click(function() {
//		checkFunc();
//	});
//
//	$('.js-form-status').click(function() {
//		checkFunc();
//	});



	/* floating banner
	 ----------------------------------------------------------------- */

	var cookieFlag = Cookies.get('banner-hidden');
	console.log(cookieFlag);

	$window.on('load scroll resize', function () {
		var $pos = $window.scrollTop();

		if ( !$('#js-floating-banner').hasClass('disactive') && cookieFlag === undefined ) {
			if ( $pos > 300 ) {
				$('#js-floating-banner').fadeIn('fast');
			} else {
				$('#js-floating-banner').fadeOut('fast');
			}
		}

	} );

	$('.js-floating-banner-close').click(function() {
		Cookies.set('banner-hidden', true, {expires: 30, path: ''});
		$('#js-floating-banner').fadeOut('fast').addClass('disactive');
	} );

});


